import { Module } from '../Module';

// This is needed for IE8 number and range validation.
Module.instance().directive('tbUserLimitValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
        // const NUMBER_REGEXP: RegExp = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))\s*$/; // From AngularJS v1.2.12

        const NUMBER_REGEXP: RegExp = /^[0-9]*$/;
        ctrl.$parsers.push((inputVal: any) => {
          const isNumber = NUMBER_REGEXP.test(inputVal);

          if(inputVal.length > 0) {
            ctrl.$setValidity('integer', isNumber);
            // min and max are inclusive
            const min = attrs['min'] ? parseFloat(attrs['min']) : -1 * Number.MAX_VALUE;
            const max = attrs['max'] ? parseFloat(attrs['max']) : Number.MAX_VALUE;

            inputVal = parseFloat(inputVal);

            ctrl.$setValidity('max', (!isNumber || inputVal <= max));
            ctrl.$setValidity('min', (!isNumber || inputVal >= min));
          } else {
            ctrl.$setValidity('integer', true);
            ctrl.$setValidity('max', true);
            ctrl.$setValidity('min', true);
          }
          return inputVal;
        });
      }
    };
  }
);
